<template>
  <div>
    <!-- 项目信息 -->
    <div class="project-info">当前项目信息：{{ projectCount }} 条</div>

    <!-- 表格 -->
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="index" label="序号" width="60" />
      <el-table-column prop="title" label="标题" />
      <el-table-column prop="publishDate" label="发布日期" width="120" />
      <el-table-column prop="fetchDate" label="获取日期" width="120" />
      <el-table-column prop="link" label="链接">
        <template slot-scope="{ row }">
          <a :href="row.link" target="_blank">{{ row.link }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="keywords" label="关键词" />
      <el-table-column prop="type" label="类型" width="100" />
      <el-table-column label="操作" width="120">
        <template slot-scope="{ row }">
          <el-button type="primary" size="mini" @click="handleAction(row, '取')">取</el-button>
          <el-button type="danger" size="mini" @click="handleAction(row, '舍')">舍</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      projectCount: 0,
      tableData: [],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const response = await fetch('/api/projects'); // 假设的 API
        const data = await response.json() | [{title:'测试', publishDate:'2023-07-01', fetchDate:'2023-07-02', link:'https://www.example.com', keywords:['关键词1', '关键词2'], type:'类型'}];1
        this.tableData = data.map((item, index) => ({
          index: index + 1,
          title: item.title,
          publishDate: item.publishDate,
          fetchDate: item.fetchDate,
          link: item.link,
          keywords: item.keywords.join(', '),
          type: item.type,
        }));
        this.projectCount = this.tableData.length;
      } catch (error) {
        console.error('获取数据失败:', error);
      }
    },
    handleAction(row, action) {
      console.log(`执行 ${action} 操作：`, row);
      // 这里可以添加实际的“取”或“舍”逻辑
    },
  },
};
</script>

<style scoped>
.project-info {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/MessageModule/AllMessage.vue